<template lang="pug">
	
	.racism
		.background-image
			.layer(ref='layer')
			.canvas-flag(ref='canvasFlag')

			img(src="assets/images/racism-crying-girl.jpg" ref='girlImg').image-2
			

		.story-wrapper
			
			section-title
				h2(slot="title-content" v-html="translate('racism.title')")

			story-text.text-1
				p(slot="text-content" v-html="translate('racism.text_1')").text 
			
			story-text.text-2
				p(slot="text-content" v-html="translate('racism.quote_1')").text

			.about-victims
				story-text
					p(slot="text-content" v-html="translate('racism.text_2')").text

				.victim-list
					.wrap-image
						img(src="assets/images/racism-list-victims.jpg")
			
			quote.large-quote
				blockquote(slot="quote" v-html="translate('racism.quote_2')")

			story-text.text-3
				p(slot="text-conte:t" v-html="translate('racism.text_3')").text  
			
			.quote-list.list-1
				quote(v-for="trad in translate('racism.quote_group_1')" :key="trad.id")  
					blockquote(slot="quote") {{trad.sentence}}
					p(slot="translation").translation {{trad.translation}}
					
			story-text.text-4
				p(slot="text-content" v-html="translate('racism.text_4')").text 


			.video-block(ref='videoWrapper')
				video-element(href='https://www.youtube.com/watch?v=WDZJPJV__bQ' poster="assets/images/temptation-thumbs.jpg" width="577" height="323" responsive title="Formation - Beyoncé" ref='video')
			
			.quote-list.list-2
				quote(v-for="(trad,i) in translate('racism.quote_group_2')" :key="trad.id")
					blockquote(slot="quote") {{trad.sentence}}
					p(slot="translation").translation {{trad.translation}}

		//- background
		bills-overlay(ref="bills")


</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import Background from '../../components/background.vue'
	import SectionTitle from '~components/content-elements/section-title.vue'
	import Quote from '~components/content-elements/quote.vue'
	import StoryText from '~components/content-elements/story-text.vue'
	import BillsOverlay from './bills-overlay.vue'
	import VideoElement from '~components/video-element.vue'
	import Globals from '~utils/Globals.js'

	import bgImg from 'assets/images/racism-joey.jpg'
	import dispImg from 'assets/images/disp-column.jpg'
	import BackgroundTools from '~utils/coverBackground.js'

  	@Component({
		name: 'Racism',
		components: { Background,SectionTitle,StoryText,Quote,BillsOverlay,VideoElement }
	})

	class Racism extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		beforeDestroy () {
			super.beforeDestroy()
		}

		init () {
			super.init()

			this.isResized = false

			this.app = new PIXI.Application(Globals.width,Globals.height,{
				antialiasing: true,
				transparent: true
			})

			this.app.renderer.autoResize = true;

			this.$refs.canvasFlag.appendChild(this.app.view)

			this.initBg()
				
		}

		initBg () {

			const loader = new PIXI.loaders.Loader();
			loader.add('bg-image',bgImg)
				  .load(this.loaded)
		}


		loaded (loader, resources) {

			this.sprite = new PIXI.Sprite.fromImage(bgImg)
			this.sprite.alpha = 0
			this.redimensionate(this.sprite)
			
			this.stage = new PIXI.Container()
			this.stage.addChild(this.sprite)

			this.displacementSprite = PIXI.Sprite.fromImage(dispImg);
			this.displacementFilter = new PIXI.filters.DisplacementFilter(this.displacementSprite);

			this.stage.filters = [this.displacementFilter]
			this.stage.addChild(this.displacementSprite)

			this.displacementFilter.scale.x = 30;

			this.app.stage.addChild(this.stage)
			this.displacementFilter.filterArea = this.app.screen;
			this.displacementFilter.padding = 0;
			this.initTimeline()

		}

		animate () {
			
		}

		raf (y) {
			super.raf(y)
		}


		_bind () {
			super._bind()
		}

		_dom () {
			this.$bg = this.$el.querySelector('.background-image')
			this.$bgLayer = this.$bg.querySelector('.layer')
			this.$bgImg1 = this.$bg.querySelector('.image-2')
			this.$billsOverlay = this.$el.querySelector('.bills-overlay')
		}

		initTimeline () {
			super.initTimeline()

			

			if(!this.sprite) return 

			this.flagTimeline = new TimelineMax({paused: true})
			this.flagTimeline.fromTo(this.displacementSprite.position,2.5,{x:-1440/2},{x:1440, ease:Power2.easeInOut},0)
			this.flagTimeline.fromTo(this.sprite,.4,{alpha:0},{alpha:1, ease: Power0.easeNone},0)
			this.flagTimeline.fromTo(this.$refs.layer,.4,{opacity:0},{opacity:.6, ease: Power0.easeNone},0)
			
			const hw_ratio = (window.innerHeight + window.innerHeight * .5) / (this.bounds.height +window.innerHeight)
			const h = window.innerHeight

			this.tl.add(()=>{

				if(this.flagTimeline) {
					const p = this.flagTimeline.progress()
					if(this.scroller.scroll.direction === 1 || this.isResized == false) {
						this.flagTimeline.play(0).timeScale( 1 )
					} else {
						TweenMax.to(this.sprite,.4,{alpha:0, ease: Power0.easeNone})
						TweenMax.to(this.$refs.layer,.4,{opacity:0, ease: Power0.easeNone})
						// this.flagTimeline.progress = 0
					}	
				}

			this.isResized = true

			},h*.8/(this.bounds.height +window.innerHeight))

			this.tl.fromTo(this.$bg,1 - (h/(this.bounds.height +window.innerHeight)),{y:-window.innerHeight},{y:(this.bounds.height - h), ease:Power0.easeNone},0)
			this.tl.fromTo(this.$refs.canvasFlag,.1,{alpha:1},{alpha:0},1 - h*2/(this.bounds.height +window.innerHeight))
			this.tl.fromTo(this.$bgImg1,.1,{opacity:0},{opacity:1},1 - h*2/(this.bounds.height +window.innerHeight))
			
			this.tl.fromTo(this.$refs.video.$el, 
			this.$refs.videoWrapper.getBoundingClientRect().width*.5 / (this.bounds.height + window.innerHeight),
			{ x: (window.innerWidth /2) - (this.$refs.videoWrapper.getBoundingClientRect().width / 2) - this.$refs.videoWrapper.getBoundingClientRect().left },
			{ x: 0 }, 
			1 - h*1.7/(this.bounds.height + window.innerHeight) )

			this.tl.fromTo(this.$billsOverlay,1,{y:-window.innerHeight},{y:(this.bounds.height), ease:Power0.easeNone},0)
			
			
			this.tl.fromTo([this.$refs.girlImg, this.$bgLayer ] ,h/(this.bounds.height +window.innerHeight) ,{y:0},{y:500, ease:Power0.easeNone},1-h/(this.bounds.height +window.innerHeight))

			this.scroller.interval('racism.bills.play',{
				start: this.bounds.top + this.bounds.height - window.innerHeight*1.3,
				end: this.bounds.top + this.bounds.height + window.innerHeight*.5,
				exec: (e)=> {
					if(!e.isInside) return
					this.$refs.bills.play(e.ratio)
				}
			})


		}

		redimensionate = (element, size = null) => {
			if(!element) return 

			const sizes = size ? size : {w: window.innerWidth, h: window.innerHeight}
			const dimension = BackgroundTools.Cover(element.width,element.height,sizes.w,sizes.h)

			element.width = dimension.w
			element.height = dimension.h
			element.position.x = dimension.pos.x
			element.position.y = dimension.pos.y
		}


		_resize () {
			super._resize()

			this.isResized = false

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height
			}

			this.sprite && this.redimensionate(this.sprite)
			if(this.app) {
				this.app.renderer.view.style.width = window.innerWidth + 'px';
				this.app.renderer.view.style.height = window.innerHeight + 'px';
				this.app.renderer.resize(window.innerWidth, window.innerHeight);
			}

			this.initTimeline()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default Racism

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.racism
		width 100%
		min-height 100vh
		background rgba(#0f0d37,0)
		position relative
		padding-bottom 40vh
		z-index 50

		.bills-overlay
			z-index 50

		.background
			z-index 30

		.background-image
			position absolute
			top 0
			left 0
			height 100vh
			width 100%
			z-index 20
			will-change transform
			overflow hidden

			.layer
				position absolute
				top 0
				left 0
				bottom 0
				right 0
				background-color $COLOR_BLUE
				opacity .7
				z-index 40
				opacity 0

			.canvas-flag
				z-index 30
				width 100%
				height 100vh
				position relative
				top 0
				left 0

				canvas
					width 100%
					height 100%

			.image-2
				z-index 20
				opacity 0

			img
				width 100%
				position absolute
				top 0
				left 0
				height 100%
				object-fit cover
		
		.section-title
			max-width 820px
			margin auto

			+break(minlg)
				max-width 1200px

			h2
				font-size em(80px)

				+break(xs)
					font-size em(60px)

		.about-victims
			display flex
			align-items flex-end
			max-width 800px
			margin auto

			+break(xs)
				flex-direction column-reverse
				align-items center

				.victim-list
					img
						max-width 100%

			.story-text
				margin-bottom 5vw
				text-align right
				padding 0 5%

				+break(xs)
					text-align center
					margin-top 20px
					margin-bottom 0

		.story-wrapper
			position relative
			z-index 50
			padding-top 20vh
			text-align center

			.text
				max-width 700px
				margin auto

				+break(minlg)
					max-width 700px

			.text-1
				margin-top 50px
				
				+break(xs)
					margin-top 30px

			.text-2
				margin-top 40px

				+break(xs)
					margin-top 30px

			.about-victims
				margin-top 50px

				+break(xs)
					margin-top 30px

			.large-quote
				max-width 800px
				margin auto
				margin-top 50px

				+break(minlg)
					max-width 1200px

				+break(xs)
					margin-top 30px

				blockquote
					line-height 2em
					font-size em(20px)

			.text-3
				margin-top 100px

				+break(xs)
					margin-top 30px

			.text-4
				margin-top 60px

			.video-block
				width 50%
				padding 0 5%
				text-align left
				margin-top 50px


			.quote-list
				max-width 820px
				margin auto
				margin-top 60px
				
				+break(minlg)
					max-width 1000px
				
				.quote
					margin-top 32px
	

</style>


// WEBPACK FOOTER //
// racism.vue?552df36c